import prechatRDPlusThemeTemplate from '../../templates/invitations/RDPlusTheme/prechat/prechat_template.ejs';
import prechatRDThemeTemplate from '../../templates/invitations/RDTheme/prechat/prechat_template.ejs';
import { ThemeStyle } from '../enums/Enum';

const importPrechatTemplateFactory = (options = {}) => {
    let prechatTemplate;
    if (ApexChat.options.skinThemeStyle == ThemeStyle.Rounded_Dynamic_Plus) {
        prechatTemplate = prechatRDPlusThemeTemplate(options)
    } else {
        prechatTemplate = prechatRDThemeTemplate(options)
    }
    return {
        prechatTemplate
    }
};
export default importPrechatTemplateFactory;
